export default {
  app: {
    title: 'AxialAdmin Magyarország'
  },

  pages: {
    index: 'Kezdőlap'
  },

  errorPage: {
    title: '404',
    description: 'A keresett oldal nem található',
    homeBtn: 'Vissza a főoldalra'
  },

  menu: {
    tenders: 'Pályázatok',
    parcels: 'Táblák',
    customers: 'Partnerek',
    calculator: 'Kalkulátor',
    offers: 'Projektek',
    orders: 'Rendelések',
    products: 'Szolgáltatások',
    availableOrders: 'Függő rendelések',
    logout: 'Kijelentkezés',
    personalData: 'Személyes adatok'
  },

  customer: {
    activate: 'Ügyfél aktiválása',
    delete: 'Ügyfél törlése',
    offers: 'Projektek megnyitása',
    offer: {
      list: {
        title: 'Ügyfél árajánlatainak/projektjeinek listája'
      }
    },
    parcel: {
      admin: {
        list: {
          title: 'Táblák'
        }
      },
      dialog: {
        archiveOffer: {
          title: 'Tábla archiválása',
          text: 'Biztosan archiválja a táblát? '
        },
        unarchiveOffer: {
          title: 'Tábla vissza aktiválása',
          text: 'Biztosan vissza aktiválja a táblát? '
        }
      },
      notification: {
        archiveSuccess: 'Tábla sikeresen archiválva!',
        archiveError: 'Tábla archiválása során hiba lépett fel!',
        unarchiveSuccess: 'Tábla sikeresen újra aktiválva!',
        unarchiveError: 'Tábla újra aktiválása során hiba lépett fel!'
      },
      status: {
        true: 'Archív',
        false: 'Nem archív'
      },
      list: {
        header: {
          status: 'Állapot'
        }
      }
    },
    tabs: {
      offers: 'Projektek',
      parcels: 'Táblák'
    },
    details: {
      title: 'Partner adatai',
      label: {
        name: 'Név',
        email: 'Email',
        status: 'Státusz',
        legalRepresentative: 'Területi képviselő',
        phoneNumber: 'Telefonszám'
      },
      maxinet: {
        label: 'mAXI-NET hitelesítés',
        check: 'Ellenőrzés',
        modal: {
          title: 'mAXI-NET ellenőrzés eredménye',
          found: 'Létező mAXI-NET felhasználó',
          notFound: 'Nem található mAXI-NET felhasználó ezzel az azonosítóval',
          activeModems: 'Aktív modemek',
          noActiveModems: 'Nincs aktív modem',
          serverError: 'A CORRIGO szerver jelenleg nem érhető el. Kérjük, próbálja újra később.'
        }
      }
    },
    list: {
      title: 'Partnerek',
      header: {
        name: 'Név',
        email: 'Email cím',
        status: 'Státusz',
        delegate: 'Területi képviselő',
        projects: 'Projektek (Aláírt / Igényelt)'
      }
    },
    status: {
      true: 'Aktív',
      false: 'Inaktív'
    },
    filter: {
      status: 'Státusz szűrő',
      activity: 'Projekt szűrő',
      activityOptions: {
        all: 'Összes partner',
        withOffer: 'Csak projektes',
        withoutOffer: 'Csak projekt nélküli'
      }
    },
    dialog: {
      activate: {
        title: 'Ügyfél felhasználójának aktiválása',
        text: 'Biztosan aktiválja a(z) <strong>{name}</strong> nevű ügyfél felhasználóját?'
      },
      delete: {
        title: 'Ügyfél felhasználójának törlése',
        text: 'Biztosan törli a(z) <strong>{name}</strong> nevű ügyfél felhasználóját? A művelet nem vonható vissza.'
      },
      onBack: {
        title: 'Mentetlen adatok',
        text: 'Az űrlap mentetlen adatokat tartalmaz! Biztosan visszalép? Ezzel a mentetlen adatok elvesznek.'
      }
    },
    notification: {
      activateSuccess: 'Partner felhasználója sikeresen aktiválva!',
      activateError: 'Partner felhasználójának aktiválása során hiba lépett fel!',
      deleteSuccess: 'Partner felhasználója sikeresen törölve!',
      deleteError: 'Partner felhasználójának törlése során hiba lépett fel!',
      appUrlMissing: 'Alkalmazás URL nincs bekonfigurálva'
    }
  },

  activityLog: {
    actionType: {
      productGroupOrdered: 'Csomag megrendelve',
      offerTransportContractSigned: 'Szállítási megállapodás aláírva',
      offerTransportContractRequested: 'Szállítási megállapodás igényelve',
      parcelCreated: 'Tábla létrehozva ({metadata} db)',
      parcelFinalized: 'Tábla véglegesítve ({metadata} db)',
      offerFinalized: 'Projekt véglegesítve',
      orderItemCompleted: 'Megrendelés teljesítve',
      productGroupCompleted: 'Szolgáltatás teljesítve'
    }
  },

  offer: {
    activityLog: 'Eseménynapló',
    farmName: 'Gazdaság neve',
    partnerAddress: 'Ügyfél címe',
    filter: {
      status: 'Státusz',
      year: 'Év',
      type: 'Típus',
      archived: 'Archív projektek megjelenítése'
    },
    approveContractModal: {
      label: {
        date: 'Támogatói okirat kiállítása'
      },
      validator: {
        required: 'A támogatói okirat kiállításának megadása kötelező!'
      }
    },
    type: {
      tender: 'Pályázatos projekt',
      extra: 'Keretszerződés',
      maximap: 'mAXI-MAP+ (demo) projekt',
      subscription: 'mAXI-MAP előfizetés'
    },
    status: {
      offerCreated: 'Projekt létrehozva',
      offerAccepted: 'Kitöltés alatt',
      userFilled: 'Véglegesítésre vár',
      finalized: 'Véglegesítve',
      transportContractRequested: 'Szállítási megállapodás igényelve',
      transportContractSigned: 'Szállítási megállapodás aláírva',
      archived: 'Archiválva',
      implementationStarted: 'Megvalósítás megkezdve',
      implementationCompleted: 'Megvalósítása teljesítve',
      maintenanceSigned: 'Fenntartási szerződés aláírva',
      completed: 'Lezárt'
    },
    contract: {
      tabs: {
        transport: 'Szállítási megállapodás',
        maintenance: 'Fenntartási szerződés',
        offer: 'Árajánlat'
      }
    },
    admin: {
      list: {
        title: 'Árajánlatok/Projektek listája',
        contractTitle: 'Szerződések',
        header: {
          offerCode: 'Projekt száma',
          companyName: 'Cégnév',
          farmName: 'Gazdaság neve',
          contactName: 'Kapcsolattartó neve',
          partnerEmail: 'Kapcsolattartó email címe',
          partnerContact: 'Elérhetőség',
          contractStatus: 'Szállítási megállapodás',
          parcelNumber: 'Gazdasághoz rendelt táblák száma',
          status: 'Státusz',
          offerAccess: 'Modul hozzáférések',
          offerType: 'Típus',
          implementationExpiresAt: 'Megvalósítás lejárata',
          finalProductGroups: 'Teljesített csomagok {year}'
        }
      }
    },
    offerTypeModal: {
      title: 'Projekt típus kiválasztása',
      label: {
        type: 'Projekt típus'
      }
    },
    updateSubscriptionRenewalDateModal: {
      title: 'Évforduló módosítása',
      label: {
        date: 'Évforduló'
      },
      validator: {
        required: 'Évforduló megadása kötelező'
      }
    },
    offerType: {
      tender: 'Pályázatos',
      extra: 'Keretszerződés',
      maximap: 'maXI-MAP+ (demo)',
      subscription: 'mAXI-MAP előfizetés'
    },
    dialog: {
      acceptOffer: {
        title: 'Elfogadás megerősítése',
        text: 'Biztos elfogadja az projektet?'
      },
      archiveOffer: {
        title: 'Archiválás megerősítése',
        text: 'Biztos arhiválja az projektet?'
      },
      approveContract: {
        title: 'Jóváhagyás megerősítése',
        text: 'Biztos minden adat stimmel?'
      },
      approveMaintenance: {
        title: 'Jóváhagyás megerősítése',
        text: 'Biztos minden adat stimmel?'
      },
      closeImplementation: {
        title: 'Megvalósítás lezárásának megerősíétse',
        text: 'Biztos lezárja a megvalósítást?'
      }
    },
    notification: {
      archiveSuccess: 'Árajánlat sikeresen archiválva!',
      archiveError: 'Árajánlat archiválása során hiba lépett fel!',
      acceptSuccess: 'Árajánlat sikeresen elfogadva!',
      acceptError: 'Árajánlat elfogadása során hiba lépett fel!'
    },
    label: {
      finalizedParcelNumber: 'Véglegesített táblák száma: ',
      lastFinalizedParcelShapesNumber: 'Generált táblák száma: ',
      renewalDate: 'Évforduló'
    },
    btn: {
      downloadParcelsShapes: 'Táblahatárok letöltése',
      generateParcelsShapes: 'Táblahatárok Shape fájl generálása'
    }
  },

  parcel: {
    filter: {
      state: 'Státusz'
    },
    status: {
      finalized: 'Véglegesítve',
      editing: 'Szerkesztés alatt',
      NEED_YEARLY_DATA: 'Javítás szükséges',
      waiting_for_finalization: 'Véglegesítésre vár',
      awaiting_yield_data: 'Hozam adat megadható',
      awaiting_planned_crop_data: 'Tervezett növény megadandó',
      awaiting_historical_yield_data: 'Hozam adat megadandó',
      agro_map_ordered: 'Táblahatár megrendelve',
      agro_map_completed: 'Táblahatár teljesítve'
    },
    parcelEdit: 'Tábla szerkesztése',
    list: {
      title: 'Táblák',
      header: {
        area: 'Terület (vektoros)',
        name: 'Tábla neve',
        source: 'Táblahatár forrása',
        status: 'Státusz',
        state: 'Kitöltve',
        proplantaStatus: 'Proplanta státusz'
      }
    },
    source: {
      vantageDraw: 'Rajzolt',
      vantageFileUpload: 'Fájlból',
      agroMap: 'AgroMAP'
    }
  },

  offerSummary: {
    header: {
      name: 'Csomag',
      type: 'Típus',
      netPrice: 'Nettó ár',
      tax: 'ÁFA ({tax}%)',
      grossPrice: 'Bruttó ár',
      amount: 'Mennyiség'
    },
    footer: {
      total: 'Végösszeg',
      totalNotice: '(Fenntartási költségek nélkül)'
    }
  },

  offerCalculator: {
    stepper: {
      calculator: 'Kalkulátor',
      summary: 'Összesítő',
      partnerData: 'Partner adatok'
    }
  },

  requestOffer: {
    companyName: 'Cégnév',
    address: 'Cím',
    taxNumber: 'Adószám',
    contactPersonName: 'Kapcsolattartó neve',
    contactPersonEmail: 'Kapcsolattartó email címe',
    contactPersonPhoneNumber: 'Kapcsolattartó telefonszáma',
    accept:
      'Beleegyezem, hogy a fenti adataimat az AXIÁL Kft. a Precíziós szolgáltatásokhoz kapcsolódó projekt elküldése érdekében tárolja, valamint a megadott elérhetőségeken felkeressen.',
    tendedersData: 'Ajánlatkérő adatai:',
    recordRequest: 'Árajánlat rögzítése',
    companyRegistrationNumber: 'Cégjegyzékszám',
    hint: {
      companyRegistrationNumber: 'BS-CF-NNNNNN formátumban.',
      taxNumber: 'xxxxxxxx-y-zz formátumban.'
    }
  },

  product: {
    label: {
      productName: 'Szolgáltatás neve',
      productCode: 'Szolgáltatás kódja',
      productGroupCode: 'Csomag kódja',
      farmName: 'Gazdaság neve',
      orderedParcelCount: 'Rendelt táblák száma',
      orderedArea: 'Rendelt terület mérete',
      orderedDate: 'Rendelés dátuma',
      status: 'Státusz',
      completion: 'Teljesítés',
      parcel: 'Tábla',
      soilSample: 'Talajminta',
      soilSampleDownload: 'Talajminta letöltés',
      soilAnalysisDownload: 'Elkészült talajlabor letöltés'
    },
    status: {
      inProgress: 'Folyamatban',
      completed: 'Teljesítve',
      dataArrived: 'Adat betöltés alatt'
    },
    unitType: {
      area: 'ha',
      hectare: 'ha',
      piece: 'db',
      null: ''
    },
    admin: {
      list: {
        title: 'Szolgáltatások'
      }
    },
    areaLimit: {
      empty: 'Nincs megadva'
    },
    dialog: {
      parcelList: {
        title: 'Rendelt táblák',
        label: {
          name: 'Név',
          status: 'Státusz'
        },
        status: {
          inProgress: 'Folyamatban',
          completed: 'Teljesítve'
        }
      },
      excelUpload: {
        title: 'Excel feltöltése: {farmName} - {name}'
      },
      complete: {
        title: 'Szolgáltatás teljesítettre állítása',
        text: 'Biztosan teljesítettre akarja állítani a szolgáltatás státuszát?'
      }
    },
    notification: {
      completeSuccess: 'Sikeresen teljesítettre állította a szolgáltatás státuszát!',
      completeError: 'A szolgáltatás teljesítettre állítása során hiba lépett fel!'
    },
    messages: {
      excelDownloadError: 'Hiba történt a fájl letöltése során',
      excelUploadError: 'Hiba történt a fájl feltöltése során',
      excelUploadSuccess: 'Sikeres feltöltés',
      shapeFilesDownloadError: 'Hiba történt a fájlok letöltése során'
    }
  },

  calculator: {
    areaLimit: 'Maximum bevonható terület',
    addedProductGroups: 'Hozzáadott csomagok',
    productGroup: {
      selector: 'Csomag választás',
      yearlyPrice: 'Éves fenntartási költség',
      select: 'Csomag kiválasztása',
      remove: 'Nem kérem a csomagot',
      price: 'Csomag ára',
      dependencies: 'Előfeltétel',
      exludes: 'Kizáró feltétel'
    },
    validation: {
      hasExcludes: 'Már hozzáadott olyan csomagokat, melyek kizáró feltételei a hozzáadni kívánt csomagnak!',
      hasNoDependency: 'A hozzáadni kívánt csomagnak nem teljesülnek az előfeltételei!',
      hasDependencyOnRemove:
        'A törölni kivánt csomag másik választott csomag előfeltétele, így előbb azokat kell törölni!',
      missingAreaLimit: 'A maximum bevonható terület nincs kitöltve!',
      amountIsBiggerThenAreaLimit: 'A megadott mennyiség nagyobb mint a maximum bevonható terület!',
      missingSelectedProductGroups: 'Minimum egy csomagot ki kell választani az projekt létrehozásához!',
      amountNotDivisibleByStep: 'A megadott mennyiség nem megfelelő!',
      amountIsLessThanMin: 'A megadott mennyiség kisebb, mint a minimum megadható mennyiség!'
    },
    dialog: {
      createOffer: {
        title: 'Megerősítés',
        text: 'Biztosan létrehozza a projektet?'
      },
      onBack: {
        title: 'Mentetlen adatok',
        text: 'Az űrlap mentetlen adatokat tartalmaz! Biztosan visszalép?'
      },
      dataToLoad: {
        title: 'Mentetlen adatok',
        text: 'Szeretné betölteni a korábban nem mentett adatait?'
      }
    },
    notification: {
      offerCreatedSuccess: 'Projekt sikeresen létrehozva!',
      offerCreatedError: 'Projekt létrehozása közben hiba történt!'
    },
    btn: {
      edit: 'Szerkesztés',
      undo: 'Visszavonás'
    }
  },

  order: {
    filter: {
      billed: {
        yes: 'Igen',
        no: 'Nem',
        label: 'Számlázva'
      }
    },
    label: {
      productGroupName: 'Csomag neve',
      offerCode: 'Projekt száma',
      farmName: 'Gazdaság neve',
      partnerName: 'Kapcsolattartó neve',
      orderDate: 'Rendelés dátuma',
      status: 'Státusz',
      billed: 'Számlázva'
    },
    status: {
      created: 'Megrendelve',
      inProgress: 'Folyamatban',
      completed: 'Teljesítve',
      orderable: 'Rendelhető',
      notOrderable: 'Nem rendelhető',
      canceled: 'Lezárt'
    },
    admin: {
      list: {
        title: 'Rendelések'
      }
    }
  },

  label: {
    or: 'vagy',
    and: 'és',
    browse: 'Tallózás'
  },

  button: {
    edit: 'Szerkesztés',
    open: 'Megtekintés',
    delete: 'Törlés',
    move: 'Áthelyezés',
    downloadOffer: 'Árajánlat letöltése',
    requestDeliveryContract: 'Szállítási megállapodás igénylése',
    requestNewOffer: 'Új árajánlat igénylése',
    save: 'Mentés',
    finalize: 'Véglegesítés',
    back: 'Vissza',
    addNewTable: 'Új tábla felvétele',
    order: 'Megrendelés',
    accept: 'Elfogadás',
    archive: 'Archiválás',
    approve: 'Jóváhagyás',
    openContract: 'Szerződések',
    addNewPriceOffer: 'Új árajánlat létrehozása',
    openParcels: 'Táblák megtekintése',
    completeProduct: 'Szolgáltatás teljesítése',
    completeParcel: 'Tábla teljesítése',
    downloadExcel: 'Fájlok letöltése',
    uploadExcel: 'Excel feltöltése',
    upload: 'Feltöltés',
    downloadShapeFiles: 'Shape fájlok letöltése',
    goToUser: 'Ugrás a felhasználóra',
    cancel: 'Mégse',
    next: 'tovább',
    closeImplementation: 'Megvalósítás lezárása',
    downloadMaintenance: 'Fenntartási szerződés letöltése',
    downloadTransport: 'Szállítási megállapodás letöltése',
    downloadLayers: 'Rétegek letöltése',
    unarchive: 'Nem archívra állítás',
    downloadAllParcels: 'Összes táblahatár letöltése',
    downloadLayerGroups: 'Összes tábla rétegek letöltése'
  },
  filter: {
    search: 'Keresés'
  },
  maximap: {
    modul: {
      map: 'Térkép',
      plan: 'Kijuttatási terv',
      monitoring: 'Monitoring'
    }
  }
};
